import { DiceComboAction } from "../DiceComboAction";

export class StealAction implements DiceComboAction {
}
